// src/components/SyncResultsModal.jsx
import React from 'react';
import './SyncResultsModal.css';

export default function SyncResultsModal({ open, onClose, data }) {
  if (!open) return null;

  const results = Array.isArray(data?.results) ? data.results : [];

  // Include draftsPulled in totals and summary
  const pulledTotal        = results.reduce((s, r) => s + Number(r.pulled || 0), 0);
  const draftsPulledTotal  = results.reduce((s, r) => s + Number(r.draftsPulled || 0), 0);
  const combinedPulledTotal = pulledTotal + draftsPulledTotal;

  const checkedTotal  = results.reduce((s, r) => s + Number(r.reconciled?.checked || 0), 0);
  const updatedTotal  = results.reduce((s, r) => s + Number(r.reconciled?.updated || 0), 0);

  const copyJson = () => {
    try {
      navigator.clipboard.writeText(JSON.stringify(data, null, 2));
    } catch {}
  };

  return (
    <div className="sr-modal-overlay" onClick={onClose}>
      <div className="sr-modal" onClick={(e) => e.stopPropagation()}>
        <div className="sr-modal-header">
          <h3>Order Sync Results</h3>
          <div style={{ display:'flex', gap:8 }}>
            <button className="btn" onClick={copyJson} title="Copy raw JSON">Copy JSON</button>
            <button className="btn" onClick={onClose} aria-label="Close">Close</button>
          </div>
        </div>

        <div className="sr-modal-body">
          <div className="sr-summary">
            <div><b>Integrations processed:</b> {results.length}</div>
            <div>
              <b>Total orders pulled:</b> {combinedPulledTotal}
              {draftsPulledTotal > 0 && (
                <span style={{ opacity:.85 }}> (&nbsp;<b>{draftsPulledTotal}</b> drafts)</span>
              )}
            </div>
            <div><b>Reconciled:</b> {checkedTotal} checked / {updatedTotal} updated</div>
            {data?.since && <div><b>Since:</b> {new Date(data.since).toLocaleString()}</div>}
          </div>

          <table className="sr-results-table">
            <thead>
              <tr>
                <th>Store</th>
                <th>Service</th>
                <th>Result</th>
                <th>Pulled</th>
                <th>Reconciled</th>
                <th>Notes / Error</th>
              </tr>
            </thead>
            <tbody>
              {results.length ? results.map((r, idx) => {
                const hasErr = !!r.error;
                const note   = r.error || r.skipped || '';
                const c      = r.reconciled?.checked ?? 0;
                const u      = r.reconciled?.updated ?? 0;
                const drafts = Number(r.draftsPulled || 0);
                return (
                  <tr key={idx} className={hasErr ? 'sr-row-error' : (r.skipped ? 'sr-row-skip' : '')}>
                    <td>{r.integrationName || r.integrationId || '-'}</td>
                    <td>{r.servicetype || '-'}</td>
                    <td>{hasErr ? 'Error' : (r.skipped ? 'Skipped' : 'OK')}</td>
                    <td>
                      {r.pulled ?? 0}
                      {drafts > 0 && (
                        <span title="Draft orders pulled" style={{ opacity:.85 }}> (+{drafts} drafts)</span>
                      )}
                    </td>
                    <td title={`Checked ${c}, Updated ${u}`}>{c} → {u}</td>
                    <td className="sr-note">{note}</td>
                  </tr>
                );
              }) : (
                <tr>
                  <td colSpan={6} style={{opacity:.7}}>No results</td>
                </tr>
              )}
            </tbody>
          </table>

          <div className="sr-raw">
            <details>
              <summary>Raw response</summary>
              <pre>{JSON.stringify(data, null, 2)}</pre>
            </details>
          </div>
        </div>

        <div className="sr-modal-footer">
          <button className="btn primary" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}